import { action, makeObservable, observable } from 'mobx';
import { TranslationKeys } from '../core/constants/translationKeys';

class CheckHashStore {
  lastRoundInfo = {
    key: '',
    salt: '',
    hash: '',
  };

  spinInfo = {
    key: '',
    salt: '',
    hash: '',
  };

  nextRoundHash = '';

  calculateSaltAndKey = {
    salt: '',
    key: '',
    hash: '',
  };

  lastRoundResult = null;

  isFromBetHistory = false;

  nextHashTextInfo = TranslationKeys.NextRound;

  constructor() {
    makeObservable(this, {
      spinInfo: observable,
      nextRoundHash: observable,
      lastRoundResult: observable,
      isFromBetHistory: observable,
      nextHashTextInfo: observable,
      lastRoundInfo: observable.deep,
      calculateSaltAndKey: observable.deep,
      setSpinInfo: action.bound,
      resetSpinInfo: action.bound,
      setLastRoundInfo: action.bound,
      setNextRoundHash: action.bound,
      setNextHashTextInfo: action.bound,
      setCalculateSaltAndKey: action.bound,
      resetCalculateSaltAndKey: action.bound,
    });
  }

  setNextHashTextInfo(text) {
    this.nextHashTextInfo = text;
  }

  setLastRoundResult(result) {
    this.lastRoundResult = { ...this.lastRoundResult, ...result };
  }

  resetCalculateSaltAndKey() {
    this.calculateSaltAndKey = {
      salt: '',
      key: '',
      hash: '',
    };
  }

  setSpinInfo(spinInfo) {
    this.spinInfo = spinInfo;
    this.isFromBetHistory = true;
  }

  resetSpinInfo() {
    this.spinInfo = {
      key: '',
      salt: '',
      hash: '',
    };
    this.isFromBetHistory = false;
  }

  setCalculateSaltAndKey(value) {
    this.calculateSaltAndKey = {
      ...this.calculateSaltAndKey,
      ...value,
    };
  }

  setLastRoundInfo(lastRoundInfo) {
    this.lastRoundInfo = lastRoundInfo;
  }

  setNextRoundHash(nextRoundHash) {
    this.nextRoundHash = nextRoundHash;
  }
}

export const checkHashStore = new CheckHashStore();
